export default __webpack_public_path__ + "static/media/story_otomo-6.82859f5b.png";